<template>
  <swiper
    :navigation="{
      nextEl: '.js-sleep-slider-next',
      prevEl: '.js-sleep-slider-prev',
    }"
    :modules="modules"
    class="sleep-slider swiper js-sleep-slider"
    :slidesPerView="'auto'"
    :spaceBetween="8"
    :breakpoints="{
      '769': {
        spaceBetween: 0,
      },
    }"
  >
    <swiper-slide
      class="swiper-slide sleep-slider__item"
      v-for="product in getProducts"
      :key="product.ID"
    >
      <BundlePoolItem :number="this.number" :product="product" />
    </swiper-slide>

    <div
      class="sleep-slider__arrow sleep-slider__arrow_prev js-sleep-slider-prev"
    >
      <svg>
        <use xlink:href="#icon-arrow-up"></use>
      </svg>
    </div>
    <div
      class="sleep-slider__arrow sleep-slider__arrow_next js-sleep-slider-next"
    >
      <svg>
        <use xlink:href="#icon-arrow-up"></use>
      </svg>
    </div>
  </swiper>
</template>

<script>
import BundlePoolItem from "./BundlePoolItem.vue";
import { Swiper, SwiperSlide } from "swiper/vue";
import { Navigation } from "swiper/modules";
import { useBundleStore } from "@/sleep_bundle/stores/bundle";
import { mapState } from "pinia";

export default {
  name: "BundlePoolSlider",
  components: { BundlePoolItem, Swiper, SwiperSlide },
  setup() {
    const store = useBundleStore();

    return {
      store,
      modules: [Navigation],
    };
  },
  props: {
    number: Number,
  },
  computed: {
    ...mapState(useBundleStore, ["getSelectedVariant"]),
    getBundle() {
      if (typeof this.getSelectedVariant !== "undefined") {
        let bundleId = Number(this.getSelectedVariant["POOL" + this.number]);

        return this.store.bundle[bundleId];
      }

      return [];
    },
    getProducts() {
      let productId = this.getBundle["PRODUCT"];
      let tagId = this.store.filter["pool" + this.number];

      return Object.values(this.store.product).filter((product) => {
        if (tagId > 0) {
          return (
            productId.includes(Number(product.ID)) &&
            typeof product.TAGS[tagId] !== "undefined"
          );
        } else {
          return productId.includes(Number(product.ID));
        }
      });
    },
  },
};
</script>
